import { Storage } from "@capacitor/storage";
import { ConfAccount } from "../../context/account/paramsAccount";
export const loadCredentials = async (config: ConfAccount) => {
    try {
        const activeUserResult = await Storage.get({ key: 'active_user' });
        const activeUser = activeUserResult?.value;
        const userCode = activeUser || config.user.user_code;

        if (userCode) {
            const userResult = await Storage.get({ key: `user_${userCode}` });
            const tokenResult = await Storage.get({ key: `token_${userCode}` });
            const confResult = await Storage.get({ key: `conf_${userCode}` });
            const user = userResult.value ? JSON.parse(userResult.value) : null;
            const token = tokenResult.value ? tokenResult.value : null;
            const conf = confResult.value ? JSON.parse(confResult.value) : null;
            if (user && token && conf) {
                return { user, token, conf };
            }
        }
        else {
            return null;
        }
    } catch (error) {
        return null;
    }
};